
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'This field is required',
});

@Component({
  components: {
    ValidationProvider,
  },
})
export default class LookupWarehouses extends Vue {
  @Prop({ type: Array, required: true }) public lookupData: string[];
  @Prop({ type: Number, required: true }) public stop_number: number;

  public loading = false;

  public addressValue = '';
  public selectItems: string[] = [];

  public showOptions = false;
  public addressChosen = '';
  private addressChosenDefault: '';

  public arrowIdx = -1;

  @Watch('addressChosen', { deep: true })
  private watchAddressChosen() {
    this.$emit('changed', this.addressChosen, this.stop_number);
  }

  private applyValueFromParent(item: string): void {
    this.addressChosen = item;
    this.addressValue = item;
    this.showOptions = false;
    this.$forceUpdate();
  }

  public async handleInput(evt: string): Promise<void> {
    this.selectItems = this.lookupData.filter(x => x.toUpperCase().indexOf(evt.toUpperCase()) >= 0);
  }

  public inputKeyPressed(evt: KeyboardEvent): void {
    // Open dropdown on Focus
    if (!this.showOptions) {
      this.showOptions = true;
      this.arrowIdx = -1;
    }
    // Close dropdown when "Escape" pressed
    if (evt.code === 'Escape') {
      this.showOptions = false;
      this.arrowIdx = -1;
    }
    // ArrowDown / ArrowUp pressed
    if (evt.code === 'ArrowDown' && this.arrowIdx < this.selectItems.length - 1) {
      this.arrowIdx += 1;
      this.fixScrolling();
    }
    if (evt.code === 'ArrowUp' && this.arrowIdx >= 1) {
      this.arrowIdx -= 1;
      this.fixScrolling();
    }
    // Enter pressed
    if (evt.code === 'Enter' && this.arrowIdx >= 0) {
      evt.preventDefault();
      this.addressChosen = this.selectItems[this.arrowIdx];
      this.addressValue = this.selectItems[this.arrowIdx];
      this.showOptions = false;
      this.arrowIdx = -1;
    }
  }

  private fixScrolling() {
    const options = this.$refs.options as HTMLFormElement;
    const scrollContainer = this.$refs.scrollContainer as HTMLFormElement;
    if (options && scrollContainer) {
      const liH = options[this.arrowIdx].clientHeight;
      scrollContainer.scrollTop = liH * this.arrowIdx;
    }
  }

  public clearInput(): void {
    this.addressValue = '';
    this.showOptions = false;
    this.addressChosen = this.addressChosenDefault;
    this.arrowIdx = -1;
    this.selectItems = [];
  }

  public inputFocused(): void {
    this.showOptions = true;
    this.selectItems = this.lookupData;
  }

  public handleItemClick(item: string): void {
    this.addressChosen = item;
    this.addressValue = item;
    this.showOptions = false;
  }

  public clickedOutside(): void {
    this.showOptions = false;
  }

  private mounted(): void {
    if (this.lookupData.length) {
      this.addressValue = this.lookupData[0];
    }
  }
}
